export default "__VITE_ASSET__BI1JNZa8__"